import React from 'react'
import LoadingButton from '@mui/lab/LoadingButton'

export const SWLoadingButton = (props?: any): JSX.Element => (
  <LoadingButton variant="contained" color="secondary" {...props}>
    {props.children}
  </LoadingButton>
)
